import { call, all, put, takeLatest } from "redux-saga/effects";

import {
  updateTaxCollectionSuccess,
  updateTaxCollectionFail,
  getTaxCollectionsListSuccess,
  getTaxCollectionsListFail,
  getTaxCollectionSuccess,
  getTaxCollectionFail,
  createPH10Success,
  createPH10Fail,
  getYearlyTotalAndPaidTaxSuccess,
  getYearlyTotalAndPaidTaxFail,
  getYearlyTotalAndPaidTaxOfZoneSuccess,
  getYearlyTotalAndPaidTaxOfZoneFail,
  getYearlyTotalAndPaidTaxOfCircleSuccess,
  getYearlyTotalAndPaidTaxOfCircleFail,
  getYearlyPaidAndPendingUnitsSuccess,
  getYearlyPaidAndPendingUnitsFail,
  getYearlyPaidAndPendingUnitsOfZoneSuccess,
  getYearlyPaidAndPendingUnitsOfZoneFail,
  getYearlyPaidAndPendingUnitsOfCircleSuccess,
  getYearlyPaidAndPendingUnitsOfCircleFail,
  getTotalRegisteredPropertiesOfZoneFail,
  getTotalRegisteredPropertiesOfZoneSuccess,
  getTaxOfZoneFail,
  getTaxOfZoneSuccess,
  getTopPaidUnitsOfZoneFail,
  getTopPaidUnitsOfZoneSuccess,
  getTopDefaultUnitsOfZoneFail,
  getTopDefaultUnitsOfZoneSuccess,
  getTotalRegisteredPropertiesOfCircleFail,
  getTotalRegisteredPropertiesOfCircleSuccess,
  getTaxOfCircleFail,
  getTaxOfCircleSuccess,
  getTopPaidUnitsOfCircleFail,
  getTopPaidUnitsOfCircleSuccess,
  getTopDefaultUnitsOfCircleFail,
  getTopDefaultUnitsOfCircleSuccess,
  getYearlyPaidTaxTiSuccess,
  getYearlyPaidTaxTiFail,
  getTITotalPendingTaxSuccess,
  getTITotalPendingTaxFail,
  getCircleOrZoneNameFail,
  getCircleOrZoneNameSuccess,
  getTaxDetailsOfPropertyBasedOnYearSuccess,
  getTaxDetailsOfPropertyBasedOnYearFail,
  generateChallanSuccess,
  generateChallanFail,
  getTaxPropertiesFail,
  getTaxPropertiesSuccess,
} from "../actionCreators/TaxCollection";
import { doGet, doPost, doPostFormData, doPut } from "../utils/request";

function* getTaxCollection({ obj }) {
  try {
    const response = yield doGet(`/taxcollection/challan?ph10_id=${obj.id}`);
    yield put(getTaxCollectionSuccess(response.data));
  } catch (err) {
    yield put(getTaxCollectionFail(err.message));
  }
}
function* createPH10({ obj }) {
  try {
    const response = yield doPost("/taxcollection/PH10", { obj });
    yield put(createPH10Success(response.data));
  } catch (err) {
    yield put(createPH10Fail(err.message));
  }
}
function* getTaxCollectionsList({ obj }) {
  try {
    const response = yield doGet(
      `/taxcollection/challans?page=${obj.page}&pageSize=${obj.pageSize}&type=${
        obj.type
      }&filters=${obj?.filter ? obj?.filter : ""}&owner=${obj.owner}`
    );

    yield put(getTaxCollectionsListSuccess(response.data));
  } catch (err) {
    yield put(
      getTaxCollectionsListFail(err.response.data.message || err.message)
    );
    yield put(getTaxCollectionsListFail());
  }
}
function* updateTaxCollection({ obj }) {
  try {
    let bodyFormData = new FormData();
    bodyFormData.append("data", JSON.stringify(obj.values));
    obj.files?.forEach((element) => {
      bodyFormData.append("file", element);
    });
    const response = yield doPostFormData(
      `/taxcollection/updateTaxCollection`,
      bodyFormData
    );

    yield put(updateTaxCollectionSuccess(response.data));
  } catch (err) {
    yield put(
      updateTaxCollectionFail(err.response.data.message || err.message)
    );
    yield put(updateTaxCollectionFail());
  }
}
function* getYearlyTotalAndPaidTax({ obj }) {
  try {
    const response = yield doGet(
      obj?.districtId
        ? `/taxcollection/yearlyTotalAndPaid?districtId=${obj?.districtId}`
        : `/taxcollection/yearlyTotalAndPaid`
    );
    yield put(getYearlyTotalAndPaidTaxSuccess(response.data));
  } catch (err) {
    yield put(
      getYearlyTotalAndPaidTaxFail(err.response.message || err.message)
    );
    yield put(getYearlyTotalAndPaidTaxFail());
  }
}
function* getYearlyTotalAndPaidTaxOfZone({ obj }) {
  try {
    const response = yield doGet(
      `/reports/yearlyPaidAndPendingTaxOfZone?zone_id=${obj.zone_id}`
    );
    yield put(getYearlyTotalAndPaidTaxOfZoneSuccess(response.data));
  } catch (err) {
    yield put(
      getYearlyTotalAndPaidTaxOfZoneFail(err.response.message || err.message)
    );
    yield put(getYearlyTotalAndPaidTaxOfZoneFail());
  }
}
function* getYearlyTotalAndPaidTaxOfCircle({ obj }) {
  try {
    const response = yield doGet(
      `/reports/yearlyPaidAndPendingTaxOfCircle?circle_id=${obj.circle_id}`
    );
    yield put(getYearlyTotalAndPaidTaxOfCircleSuccess(response.data));
  } catch (err) {
    yield put(
      getYearlyTotalAndPaidTaxOfCircleFail(err.response.message || err.message)
    );
    yield put(getYearlyTotalAndPaidTaxOfCircleFail());
  }
}
function* getYearlyPaidAndPendingUnits({ obj }) {
  try {
    const response = yield doGet(
      obj?.districtId
        ? `/taxcollection/yearlyNoOfPaidAndPendingUnits?districtId=${obj?.districtId}`
        : `/taxcollection/yearlyNoOfPaidAndPendingUnits`
    );
    yield put(getYearlyPaidAndPendingUnitsSuccess(response.data));
  } catch (err) {
    yield put(
      getYearlyPaidAndPendingUnitsFail(err.response.message || err.message)
    );
    yield put(getYearlyPaidAndPendingUnitsFail());
  }
}
function* getYearlyPaidAndPendingUnitsOfZone({ obj }) {
  try {
    const response = yield doGet(
      `/reports/yearlyPaidAndPendingPropertiesfZone?zone_id=${obj.zone_id}`
    );
    yield put(getYearlyPaidAndPendingUnitsOfZoneSuccess(response.data));
  } catch (err) {
    yield put(
      getYearlyPaidAndPendingUnitsOfZoneFail(
        err.response.message || err.message
      )
    );
    yield put(getYearlyPaidAndPendingUnitsOfZoneFail());
  }
}
function* getYearlyPaidAndPendingUnitsOfCircle({ obj }) {
  try {
    const response = yield doGet(
      `/reports/yearlyPaidAndPendingPropertiesfCircle?circle_id=${obj.circle_id}`
    );
    yield put(getYearlyPaidAndPendingUnitsOfCircleSuccess(response.data));
  } catch (err) {
    yield put(
      getYearlyPaidAndPendingUnitsOfCircleFail(
        err.response.message || err.message
      )
    );
    yield put(getYearlyPaidAndPendingUnitsOfCircleFail());
  }
}
function* getTotalRegisteredPropertiesOfZone({ obj }) {
  try {
    const response = yield doGet(
      `/reports/yearlyRegisteredPropertiesOfZone?zone_id=${obj.zone_id}`
    );
    yield put(getTotalRegisteredPropertiesOfZoneSuccess(response.data));
  } catch (err) {
    yield put(
      getTotalRegisteredPropertiesOfZoneFail(
        err.response.message || err.message
      )
    );
    yield put(getTotalRegisteredPropertiesOfZoneFail());
  }
}
function* getTaxOfZone({ obj }) {
  try {
    const response = yield doGet(
      `/reports/totalTaxOfZone?zone_id=${obj.zone_id}`
    );
    yield put(getTaxOfZoneSuccess(response.data));
  } catch (err) {
    yield put(getTaxOfZoneFail(err.response.message || err.message));
    yield put(getTaxOfZoneFail());
  }
}
function* getTopPaidUnitsOfZone({ obj }) {
  try {
    const response = yield doGet(
      `/reports/topPaidUnitsOfZone?zone_id=${obj.zone_id}`
    );
    yield put(getTopPaidUnitsOfZoneSuccess(response.data));
  } catch (err) {
    yield put(getTopPaidUnitsOfZoneFail(err.response.message || err.message));
    yield put(getTopPaidUnitsOfZoneFail());
  }
}
function* getTopDefaultUnitsOfZone({ obj }) {
  try {
    const response = yield doGet(
      `/reports/topDefaultUnitsOfZone?zone_id=${obj.zone_id}`
    );
    yield put(getTopDefaultUnitsOfZoneSuccess(response.data));
  } catch (err) {
    yield put(
      getTopDefaultUnitsOfZoneFail(err.response.message || err.message)
    );
    yield put(getTopDefaultUnitsOfZoneFail());
  }
}
function* getTotalRegisteredPropertiesOfCircle({ obj }) {
  try {
    const response = yield doGet(
      `/reports/yearlyRegisteredPropertiesOfCircle?circle_id=${obj.circle_id}`
    );
    yield put(getTotalRegisteredPropertiesOfCircleSuccess(response.data));
  } catch (err) {
    yield put(
      getTotalRegisteredPropertiesOfCircleFail(
        err.response.message || err.message
      )
    );
    yield put(getTotalRegisteredPropertiesOfCircleFail());
  }
}
function* getTaxOfCircle({ obj }) {
  try {
    const response = yield doGet(
      `/reports/totalTaxOfCircle?circle_id=${obj.circle_id}`
    );
    yield put(getTaxOfCircleSuccess(response.data));
  } catch (err) {
    yield put(getTaxOfCircleFail(err.response.message || err.message));
    yield put(getTaxOfCircleFail());
  }
}
function* getTopPaidUnitsOfCircle({ obj }) {
  try {
    const response = yield doGet(
      `/reports/topPaidUnitsOfCircle?circle_id=${obj.circle_id}`
    );

    yield put(getTopPaidUnitsOfCircleSuccess(response.data));
  } catch (err) {
    yield put(getTopPaidUnitsOfCircleFail(err.response.message || err.message));
    yield put(getTopPaidUnitsOfCircleFail());
  }
}
function* getTopDefaultUnitsOfCircle({ obj }) {
  try {
    const response = yield doGet(
      `/reports/topDefaultUnitOfCircle?circle_id=${obj.circle_id}`
    );
    yield put(getTopDefaultUnitsOfCircleSuccess(response.data));
  } catch (err) {
    yield put(
      getTopDefaultUnitsOfCircleFail(err.response.message || err.message)
    );
    yield put(getTopDefaultUnitsOfCircleFail());
  }
}

function* getYearlyPaidTaxTi({ obj }) {
  try {
    const response = yield doGet(
      `/taxcollection/getYearlyPaidTaxTi/${obj.tiId}/circle/${obj.circleId}`
    );
    yield put(getYearlyPaidTaxTiSuccess(response.data));
  } catch (err) {
    yield put(getYearlyPaidTaxTiFail(err.response.message || err.message));
    yield put(getYearlyPaidTaxTiFail());
  }
}

function* getTITotalPendingTax({ obj }) {
  try {
    const response = yield doGet(
      `/taxcollection/getPendingTaxTi/${obj.tiId}/circle/${obj.circleId}`
    );
    yield put(getTITotalPendingTaxSuccess(response.data));
  } catch (err) {
    yield put(getYearlyPaidTaxTiFail(err.response.message || err.message));
    yield put(getTITotalPendingTaxFail());
  }
}
function* getCircleOrZoneName({ obj }) {
  try {
    let response;
    if (obj?.circle_id) {
      response = yield doGet(
        `/reports/circlezoneName?circle_id=${obj.circle_id}`
      );
    } else if (obj.zone_id) {
      response = yield doGet(`/reports/circlezoneName?zone_id=${obj.zone_id}`);
    }
    yield put(getCircleOrZoneNameSuccess(response.data));
  } catch (err) {
    yield put(getCircleOrZoneNameFail(err.response.message || err.message));
    yield put(getCircleOrZoneNameFail());
  }
}

function* getTaxDetailsPropertyBasedOnYear({ obj }) {
  try {
    const { fiscalYear, propertyId } = obj;
    const response = yield doGet(
      `/taxcollection/${fiscalYear}/property/${propertyId}`
    );
    yield put(getTaxDetailsOfPropertyBasedOnYearSuccess(response.data));
  } catch (err) {
    yield put(
      getTaxDetailsOfPropertyBasedOnYearFail(
        err.response.message || err.message
      )
    );
    yield put(getTaxDetailsOfPropertyBasedOnYearFail());
  }
}

function* generateChallan({ obj }) {
  try {
    const response = yield doPost("/taxcollection/createChallan", obj);
    yield put(generateChallanSuccess(response.data));
  } catch (err) {
    yield put(generateChallanFail(err.message || err.response.message));
    yield put(generateChallanFail());
  }
}
function* getTaxPropertiesList({ obj }) {
  try {
    const response = yield doGet(
      `/taxcollection/properties?page=${obj.page}&pageSize=${obj.pageSize}&pin=${obj.pin}`
    );

    yield put(getTaxPropertiesSuccess(response.data));
  } catch (err) {
    yield put(getTaxPropertiesFail(err.response.data.message || err.message));
    yield put(getTaxPropertiesFail());
  }
}

export default function* watcher() {
  yield all([
    takeLatest("GET_TAX_COLLECTIONS_LIST", getTaxCollectionsList),
    takeLatest("GET_TAX_COLLECTION", getTaxCollection),
    takeLatest("CREATE_PH10", createPH10),
    takeLatest("UPDATE_TAX_COLLECTION", updateTaxCollection),
    takeLatest("GET_YEARLY_TOTAL_AND_PAID_TAX", getYearlyTotalAndPaidTax),
    takeLatest(
      "GET_YEARLY_PAID_AND_PENDING_UNITS",
      getYearlyPaidAndPendingUnits
    ),
    takeLatest(
      "GET_YEARLY_TOTAL_AND_PAID_TAX_OF_ZONE",
      getYearlyTotalAndPaidTaxOfZone
    ),
    takeLatest(
      "GET_YEARLY_PAID_AND_PENDING_UNITS_OF_ZONE",
      getYearlyPaidAndPendingUnitsOfZone
    ),
    takeLatest(
      "GET_YEARLY_PAID_AND_PENDING_UNITS_OF_CIRCLE",
      getYearlyPaidAndPendingUnitsOfCircle
    ),
    takeLatest(
      "GET_YEARLY_TOTAL_AND_PAID_TAX_OF_CIRCLE",
      getYearlyTotalAndPaidTaxOfCircle
    ),
    takeLatest(
      "GET_TOTAL_REGISTERED_PROPERTIES_OF_ZONE",
      getTotalRegisteredPropertiesOfZone
    ),
    takeLatest("GET_TAX_OF_ZONE", getTaxOfZone),
    takeLatest("GET_TOP_PAID_UNITS_OF_ZONE", getTopPaidUnitsOfZone),
    takeLatest("GET_TOP_DEFAULT_UNITS_OF_ZONE", getTopDefaultUnitsOfZone),
    takeLatest(
      "GET_TOTAL_REGISTERED_PROPERTIES_OF_CIRCLE",
      getTotalRegisteredPropertiesOfCircle
    ),
    takeLatest("GET_TAX_OF_CIRCLE", getTaxOfCircle),
    takeLatest("GET_TOP_PAID_UNITS_OF_CIRCLE", getTopPaidUnitsOfCircle),
    takeLatest("GET_TOP_DEFAULT_UNITS_OF_CIRCLE", getTopDefaultUnitsOfCircle),
    takeLatest(
      "GET_YEARLY_PAID_AND_PENDING_UNITS",
      getYearlyPaidAndPendingUnits
    ),
    takeLatest("GET_YEARLY_PAID_TAX_TI", getYearlyPaidTaxTi),
    takeLatest("GET_TI_TOTAL_PENDING_TAX", getTITotalPendingTax),
    takeLatest("GET_CIRCLE_OR_ZONE_NAME", getCircleOrZoneName),
    takeLatest(
      "GET_TAX_DETAILS_PROPERTY_BASED_ON_YEAR",
      getTaxDetailsPropertyBasedOnYear
    ),
    takeLatest("GENERATE_CHALLAN", generateChallan),
    takeLatest("GET_TAX_PROPERTIES", getTaxPropertiesList),
  ]);
}
